// German for the discharge dialogue — closing a commitment with its evidence.
import { registerDe } from '../i18n/index.js';

registerDe({
  '{ref} discharged — the ball moves.': '{ref} erfüllt — der Ball wandert weiter.',
  'Discharge {ref}': '{ref} erfüllen',
  'made {date}': 'gegeben am {date}',
  'owner {owner}': 'verantwortlich {owner}',
  'unrecorded': 'nicht erfasst',
  'Discharged on — the date the promise was kept': 'Erfüllt am — das Datum, an dem das Versprechen gehalten wurde',
  "Evidence — what kept it. Exactly one, and it must be this client's.": 'Beleg — was es gehalten hat. Genau einer, und er muss zu diesem Kunden gehören.',
  'A document': 'Ein Dokument',
  'An event': 'Ein Ereignis',
  '— pick the document that kept the promise —': '— das Dokument wählen, das das Versprechen gehalten hat —',
  '— pick the event that kept the promise —': '— das Ereignis wählen, das das Versprechen gehalten hat —',
  'Note — optional, one line on how it was kept': 'Notiz — optional, eine Zeile dazu, wie es gehalten wurde',
  'Cancel': 'Abbrechen',
  'Recording…': 'Wird erfasst…',
  'Record the discharge': 'Erfüllung erfassen',
}, 'DischargeModal');
